import React,{Component} from 'react';
import { ref , storage } from '../config/constants'



class JobOrderDownload extends Component{
    constructor(){
        super();
        
            this.state={
                downloadUrl : ''
            }
        }

     componentDidMount() {
         var storageRef = storage.child("JobOrder/"+ this.props.job.jobFile);

        // Get the download URL
        storageRef.getDownloadURL().then(function(url) {
          this.setState({
            downloadUrl : url
          })
            
        }.bind(this)).catch(function(error) {

          // A full list of error codes is available at
          // https://firebase.google.com/docs/storage/web/handle-errors
          switch (error.code) {
            case 'storage/object_not_found':
              alert("File doesn't exist");
              break;

            case 'storage/unauthorized':
                alert ("User doesn't have permission to access the object")
              break;

            case 'storage/canceled':
              alert("User canceled the upload");
              break;
            case 'storage/unknown':
              alert ("Unknown error occurred, inspect the server response")
              break;
          }
        })
         
    }

    

    
    
    render() {
            
        return (

                <div className="submitContract text-center">
                    <p>Download job order file for quotation {this.props.job.quoteNumber}</p>
                    <p>File Name: {this.props.job.jobFile} </p>                  
                   <a href={this.state.downloadUrl} className="btn btn-primary"><i className="fa fa-floppy-o"></i> Download</a>
                </div>
            
        );
    }
}

export default  JobOrderDownload;



// WEBPACK FOOTER //
// ./src/components/JobOrderDownload.js